/**
*
* TicketComponent
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import getFrontendHost from 'getFrontendHost';

import setLanguageContent from 'helpers/setLanguageContent';
import checkIfNumber from 'helpers/checkIfNumber';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';


window.titoHooks = false;

function titoAddHooks() {




  const getEventTitle = eventData && eventData.template && eventData.template.templateSchema ? setLanguageContent(eventData.template.templateSchema, 'title', 'en') : 'purchase';
  Tito.on('registration:finished', function(data){

    if (typeof ga === 'function' && data) {

      const checkTotal = checkIfNumber(data.total);
      if (checkIfNumber !== false && dataLayer) {
        dataLayer.push({
          'event': 'Acara - Events',
          'category': 'Acara - Events',
          'action': Number(checkTotal) > 0  ? 'acara.purchase.paid' : 'acara.purchase.free',
          'label': getEventTitle,
          'value': Number(checkTotal)
         });
      }

    }
  });

}

class RedTicketsTicket extends React.PureComponent {

  constructor() {
    super();

    this.ticketRef = React.createRef();

    this.handleTito = this.handleTito.bind(this);

  }


  handleTito() {
    if (!this.props.commonProps.isEditor && this.ticketRef && this.ticketRef.current) {
      if (this.ticketRef.current.querySelector('.tito-tickets-button')) {
        this.ticketRef.current.querySelector('tito-button').click();
      } else {
        Tito.buildWidgets();
        if (!window.titoHooks) {
          window.titoHooks = true;
          titoAddHooks();
        }
        setTimeout(() => {
          this.ticketRef.current.querySelector('tito-button').click();
        }, 1250);  
      }      
    }
  }



  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      highlighted,
      language,
      ticketContent,
      hasTito
    } = this.props;

    const {
      numberSold,
      numberAvailable,
      customUrl
    } = ticketContent;



    const isSoldOutFromTicket = numberSold >= numberAvailable;

    const soldOut = ticketContent.soldOut || !customUrl && isSoldOutFromTicket ? (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'ticketSoldOut'}
        defaultValues={defaultTextValues}
        type={'text'}
        editorData={
          {
            editorType: 'ticketSoldOut',
            ...commonData
          }
        }

      />
    ) : '';

    let titoEvent;
    let titoReleases;
    let titoDiscount;

    if (hasTito) {
      const titoUrlSplit = new URL(ticketContent.customUrl).pathname.split( '/' );
      titoReleases = titoUrlSplit[4];
      titoEvent = titoUrlSplit[1];
      titoEvent = titoEvent +'/'+titoUrlSplit[2];
      titoDiscount = titoUrlSplit.length >= 7 ? titoUrlSplit[6] : '';  
    }



    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={highlighted ? `ticketHighlightedWrapper` : `ticketWrapper`}
        editorData={
          {
            editorType: highlighted ? `ticketHighlightedWrapper` : `ticketWrapper`,
            ...commonData
          }
        }
        innerRef={this.ticketRef}
      >
        {soldOut}
        {
          highlighted ? (
            <Wrapper
              {...commonProps}
              
              typeOfStyle={`ticketHighlighted`}
              type={'text'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: `ticketHighlighted`,
                  ...commonData
                }
              }
            />
          ) : ''
        }

        <Wrapper
          {...commonProps}
          
          typeOfStyle={'ticketPriceInfoWrapper'}
          editorData={
            {
              editorType: 'ticketPriceInfoWrapper',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={highlighted ? 'ticketHighlightedTitle' : 'ticketTitle'}
            editorData={
              {
                editorType: highlighted ? 'ticketHighlightedTitle' : 'ticketTitle',
                ...commonData
              }
            }
          >
            {setLanguageContent(ticketContent, 'title', language)}
          </Wrapper>

          {
            ticketContent.prevPrice ? (
                <Wrapper
                {...commonProps}
                
                typeOfStyle={highlighted ? 'ticketHighlightedPreviousPrice' : 'ticketPreviousPrice'}
                editorData={
                  {
                    editorType: highlighted ? 'ticketHighlightedPreviousPrice' : 'ticketPreviousPrice',
                    ...commonData
                  }
                }
              >
                {ticketContent.prevPrice ? `${ticketContent.currency.toUpperCase() +' '+ ticketContent.prevPrice}` : '0'}
              </Wrapper>
            ) : ''
          }
  
        <Wrapper
            {...commonProps}
            
            typeOfStyle={highlighted ? 'ticketHighlightedPriceCrossed' : 'ticketPriceCrossed'}
            editorData={
              {
                editorType: highlighted ? 'ticketHighlightedPriceCrossed' : 'ticketPriceCrossed',
                ...commonData
              }
            }
          >
            {ticketContent.crossedFakePrice ? `${ticketContent.currency.toUpperCase() +' '+ ticketContent.crossedFakePrice}` : ''}
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={highlighted ? 'ticketHighlightedPrice' : 'ticketPrice'}
            editorData={
              {
                editorType: highlighted ? 'ticketHighlightedPrice' : 'ticketPrice',
                ...commonData
              }
            }
          >
            {ticketContent.isFree ? 'FREE' : ticketContent.price ? `${ticketContent.currency.toUpperCase() +' '+ ticketContent.price + (ticketContent.priceChange && ticketContent.priceChange !== '00' ? '.'+ticketContent.priceChange : '' )}` : '0'}
          </Wrapper>
          {
            ticketContent.disableAutmaticTax || ticketContent.isFree ? '' : (
              <Wrapper
              {...commonProps}
              
              defaultValues={defaultTextValues}
              typeOfStyle={highlighted ? 'ticketHighlightedTax' : 'ticketTax'}
              type={'text'}
              editorData={
                {
                  editorType: highlighted ? 'ticketHighlightedTax' : 'ticketTax',
                  ...commonData
                }
              }
            />
            )
          }
          {
            ticketContent.subtitle ? (
              <Wrapper
                {...commonProps}
                
                typeOfStyle={highlighted ? 'ticketHighlightedTax' : 'ticketSubtitle'}
                editorData={
                  {
                    editorType: highlighted ? 'ticketHighlightedTax' : 'ticketSubtitle',
                    ...commonData
                  }
                }
              >
                {setLanguageContent(ticketContent, 'description', language)}
              </Wrapper>
            ): ''
          }
        </Wrapper>
        {hasTito ? 
        <div dangerouslySetInnerHTML={{__html: `<tito-button style="display:none;" id="${titoReleases+titoEvent.replace('/').replace(/[0-9]/g, '')}" event="${titoEvent}" releases="${titoReleases}" discount-code="${titoDiscount}"></tito-button>`}}></div>
        
        : ''}
        <Wrapper
          {...commonProps}
          
          typeOfStyle={highlighted ? `ticketHighlightedBuyButton` : `ticketBuyButton`}          
          type={'text'}
          defaultValues={defaultTextValues}
          href={hasTito ? null : customUrl ? customUrl : getFrontendHost()+'dashboard/checkout/'+ticketContent.ticketId}
          disableLinkEdit={true}
          handleClick={hasTito ? this.handleTito : null}
          target={'_blank'}
          editorData={
            {
              editorType: highlighted ? `ticketHighlightedBuyButton` : `ticketBuyButton`,
              ...commonData
            }
          }
        />
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'ticketLine'}
          editorData={
            {
              editorType: 'ticketLine',
              ...commonData
            }
          }
        />
        <Wrapper
          {...commonProps}
          
          typeOfStyle={highlighted ? `ticketHighlightedDescription` : `ticketDescription`}
          editorData={
            {
              editorType: highlighted ? `ticketHighlightedDescription` : `ticketDescription`,
              ...commonData
            }
          }
        >
          {setLanguageContent(ticketContent, 'description', language)}
        </Wrapper>
      </Wrapper>
    );

  }
}

RedTicketsTicket.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  ticket: PropTypes.object,
  highlighted: PropTypes.bool
};

export default RedTicketsTicket;
